module.exports = __webpack_public_path__ + "static/media/pla_clear_green_stripes_straw3.1460ac2d.png";